import React from 'react';

import { SVGComponentProps } from './svg.types';

const TaskHistorytaskCompleteSVG = ({
  fill = 'currentColor',
  size = '1em',
  wrapperClass,
  ...otherProps
}: SVGComponentProps) => {
  return (
    <span className={`inline-block ${wrapperClass || ''}`}>
      <svg
        width="32"
        height="32"
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle cx="16" cy="16" r="16" fill="#DFF8E3" />
        <circle cx="16" cy="16" r="6" fill="#2B303B" />
        <g clipPath="url(#clip0_6149_102090)">
          <path
            d="M14.2708 18.7285L12.2862 16.7434C12.1952 16.6524 12.1229 16.5444 12.0737 16.4255C12.0244 16.3067 11.999 16.1792 11.999 16.0505C11.999 15.9218 12.0244 15.7944 12.0737 15.6755C12.1229 15.5566 12.1952 15.4486 12.2862 15.3577C12.47 15.1741 12.7192 15.071 12.979 15.071C13.2389 15.071 13.4881 15.1741 13.6719 15.3577L14.9148 16.5994C14.9398 16.6243 14.9737 16.6383 15.009 16.6383C15.0444 16.6383 15.0783 16.6243 15.1033 16.5994L18.3262 13.3765C18.51 13.193 18.7592 13.0898 19.019 13.0898C19.2789 13.0898 19.5281 13.193 19.7119 13.3765C19.8029 13.4675 19.8752 13.5755 19.9244 13.6944C19.9737 13.8133 19.9991 13.9407 19.9991 14.0694C19.9991 14.1981 19.9737 14.3255 19.9244 14.4444C19.8752 14.5633 19.8029 14.6713 19.7119 14.7622L15.7462 18.7285C15.5505 18.9242 15.2852 19.034 15.0085 19.034C14.7318 19.034 14.4664 18.9242 14.2708 18.7285Z"
            fill="#DFF8E3"
          />
        </g>
        <defs>
          <clipPath id="clip0_6149_102090">
            <rect width="8" height="8" fill="white" transform="translate(12 12)" />
          </clipPath>
        </defs>
      </svg>
    </span>
  );
};

export default TaskHistorytaskCompleteSVG;
